module.exports = __webpack_public_path__ + "static/media/Bulk_transfer.088a67a6.svg";